import { InpPaginated, InspectDatsRequest } from './Inp';
import InpRepository from './InpRepository';
import { ControlKpiResponse, Configuration, ApiResponse } from './controlkpi';

export default class InpService {
  private readonly inpRepository: InpRepository = new InpRepository();

  async getModelFilesByOrganization({
    organizationId,
    page = 1,
    size = 20,
    name,
    locationId,
    onlyCompleted,
    hasControlKpi
  }: {
    organizationId: number;
    page?: number;
    size?: number;
    name?: string | null;
    locationId?: number | null;
    onlyCompleted?: boolean | null;
    hasControlKpi?: boolean | null;
  }) {
    const response = await this.inpRepository.getModelFilesByOrganization({
      organizationId,
      page,
      size,
      name,
      locationId,
      onlyCompleted,
      hasControlKpi
    });
    return {
      totalRecords: response.totalRecords,
      inpFiles: response.getAllResponseDTOList,
    } as InpPaginated;
  }

  async uploadInps(
    userId: string,
    organizationId: string,
    data: any,
  ): Promise<boolean> {
    return this.inpRepository.uploadInps(userId, organizationId, data);
  }
  async changeStatusInp(inpId: any, status: boolean): Promise<boolean> {
    return this.inpRepository.changeStatusInp(inpId, status);
  }

  async getDatsFromInp(data: InspectDatsRequest): Promise<string[]> {
    return this.inpRepository.getDatsFromInp(data);
  }

  async getModelInfrastructureId({
    inpId,
    typeId,
    name = null,
    page = 1,
    size = 10000,
    assetType = null,
  }: {
    inpId: any;
    typeId: any;
    name?: null | string;
    page?: number;
    size?: number;
    assetType?: string | null;
  }): Promise<any> {
    return this.inpRepository.getModelInfrastructureId(
      inpId,
      typeId,
      name,
      page,
      size,
      assetType,
    );
  }

  async enableInp(inpId: string | number, enabled: boolean): Promise<boolean> {
    return this.inpRepository.enableInp(inpId, enabled);
  }
  async disableInp(inpId: string | number, enabled: boolean): Promise<boolean> {
    return this.inpRepository.disableInp(inpId, enabled);
  }
  async deleteInps(inpId: number): Promise<boolean> {
    return this.inpRepository.deleteInps(inpId);
  }

  async saveBaseline(
    inpId: number | string,
    data: { inpBaselineName: string; inpData: string },
  ): Promise<any> {
    return this.inpRepository.saveBaseline(inpId, data);
  }

  async deleteBaseline(inpId: number | string): Promise<any> {
    return this.inpRepository.deleteBaseline(inpId);
  }

  async getControlKpi(inpId: number): Promise<ControlKpiResponse[]> {
    return this.inpRepository.getControlKpi(inpId);
  }

  async saveControlKpi({
    inpId,
    locationId,
    configuration
  }: {
    inpId: number;
    locationId: number;
    configuration: Configuration;
  }): Promise<ApiResponse> {
    return this.inpRepository.saveControlKpi({ inpId, locationId, configuration });
  }

  async deleteControlKpi(inpId: number): Promise<ApiResponse> {
    return this.inpRepository.deleteControlKpi(inpId);
  }
}
